<div class="container mx-4 my-3">
  <div class="selected-video">
    <div class="grid">
      <div class="col-7 pt-0">
        <div class="flex flex-column flex-wrap">
          <div class="flex align-items-start justify-content-start">
            <span class="video-name" [title]="video_content_data.name">{{
              video_content_data.name | ellipses
              }}</span>
          </div>
          <div class="flex align-items-start justify-content-start">
            <span class="description">Drag and Drop the sentences in the window below to create a new
              video</span>
          </div>
        </div>
      </div>
      <div class="col-5 px-0">
        <div class="flex flex-row justify-content-end flex-wrap gap-2">
          <div class="flex align-items-center justify-content-center">
            <p-button label="Reset" class="export-btn" icon="pi pi-refresh" iconPos="right"
              [disabled]="!targetProducts.length" (click)="deleteTargetItems()">
            </p-button>
          </div>
          <div class="flex align-items-center justify-content-center">
            <p-button label="Export EDL" class="export-btn" icon="pi pi-download" iconPos="right"
              [disabled]="isNewVideoCreated" (click)="onExportCSV()" [ngClass]="
                isNewVideoCreated ? 'cursor-default' : 'cursor-pointer'
              ">
            </p-button>
          </div>
          <div class="flex align-items-center justify-content-center">
            <p-button label="Download" class="download-btn" icon="pi pi-download" iconPos="right"
              [disabled]="isNewVideoCreated" (click)="onDownloadNewVideo()" [ngClass]="
                isNewVideoCreated ? 'cursor-default' : 'cursor-pointer'
              ">
            </p-button>
          </div>
        </div>
      </div>
    </div>
    <div class="grid my-3">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="row">
          <div class="col pt-0">
            <span class="video-title">Source Video</span>
          </div>
        </div>
        <div class="current-video">
          <app-video-player (player_event)="handle_player_events($event)"
            (player_reference)="handle_player_reference($event)" [playable_content]="video_content_data"
            [options]="video_player_options"></app-video-player>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="row">
          <div class="col pt-0 pl-25rem">
            <span class="video-title">New Video</span>
          </div>
        </div>
        <div class="transcript">
          @if (isNewVideoCreated) {
          <div class="no-video relative">
            <p-button label="Preview" class="preview-btn" (click)="onLoadNewVideo()" [ngClass]="
                !showLoadedVideo
                  ? 'btn-disabled pointer-events-none'
                  : 'btn-enabled'
              "></p-button>
          </div>
          } @else {
          <div class="no-video relative">
            <p-button label="Preview" class="preview-new btn-enabled" (click)="onLoadNewVideo()"
              *ngIf="showLoadedVideo"></p-button>
            <app-video-player (player_event)="handle_target_events($event)"
              (player_reference)="handle_output_target_reference($event)" [playable_content]="video_target_data"
              [options]="video_player_options1" [id]="'newvideo'"></app-video-player>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="new-video">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <div class="card" id="transcript_card">
          <!-- <p-pickList [source]="sourceProducts" [target]="targetProducts" sourceHeader="" targetHeader=""
            [dragdrop]="true" [responsive]="true" breakpoint="1400px" (onMoveToTarget)="onMoveTarget($event)"
            (onTargetReorder)="onTargetReorder()" (onMoveToSource)="onMoveToSource($event)"
            (onMoveAllToTarget)="onMoveAllToTarget($event)" (onSourceSelect)="onSourceSelect()"
            (onSourceReorder)="onSourceReorder($event)">
            <ng-template let-target pTemplate="item1">
              <div #targetItem class="target-item" [id]="'transcsripts_' + target.startTime"
                (dblclick)="disableDBLClick($event)">
                <div class="flex flex-wrap p-2 align-items-center gap-3" [ngClass]="
                    target.isCopied
                      ? 'disabled-bg pointer-events-none'
                      : 'enabled-bg pointer-events-auto'
                  ">
                  <div class="flex-1 flex flex-column gap-2">
                    <div class="flex align-items-center gap-2"
                      (click)="targetItem?.closest('.p-picklist-source')?handle_click_on_transcript(target.startTime):handle_click_on_output_transcript(target.startTime)">
                      @for (final of target.diarization_data; track $index) {
                      <div class="speaker-list">
                        <div class="speaker-value">
                          <span class="speaker"> {{ final.speaker }}</span>
                          <span class="speaker-time">
                            ({{ get_frames_time(target.startTime) }})
                          </span>
                        </div>
                        <span>: &nbsp;</span>
                        <span class="speaker-text mr-2">{{
                          final.content_spoken
                          }}</span>
                      </div>
                      }
                      <div class="flex align-items-center gap-2" *ngIf="targetItem?.closest('.p-picklist-target')">
                        <div class="absolute right-0 px-2">
                          <span class="delete-action" (click)="onDeleteTargetItem(target)">
                            <i class="delete-btn pi pi-trash"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-pickList> -->
          <p-pickList [source]="sourceProducts" [target]="targetProducts" sourceHeader="" targetHeader=""
            [dragdrop]="true" [responsive]="true" breakpoint="1400px" (onMoveToTarget)="onMoveTarget($event)"
            (onTargetReorder)="onTargetReorder()" (onMoveToSource)="onMoveToSource($event)"
            (onMoveAllToTarget)="onMoveAllToTarget($event)" (onSourceSelect)="onSourceSelect()"
            (onSourceReorder)="onSourceReorder($event)" (onTargetSelect)="onTargetSelect($event)">
            <ng-template let-target pTemplate="item">
              @for (final of target.diarization_data; track $index) {
              <div #targetItem class="target-item" [id]="'transcsripts_' + target.startTime"
                (dblclick)="disableDBLClick($event)">
                <div class="flex flex-wrap p-2 align-items-center gap-3" [ngClass]="
                target.isCopied
                  ? 'disabled-bg'
                  : 'enabled-bg'
              ">
                  <div class="flex-1 flex flex-column gap-2">
                    <div class="flex align-items-center gap-2"
                      (click)="targetItem?.closest('.p-picklist-source')?handle_click_on_transcript(target.startTime):handle_click_on_output_transcript(target.startTime)">
                      <div class="speaker-list">
                        <div class="speaker-value">
                          <span class="speaker"> {{ final.speaker }}</span>
                          <span class="speaker-time">
                            ({{ get_frames_time(target.startTime) }})
                          </span>
                        </div>
                        <span>: &nbsp;</span>
                        <span class="speaker-text mr-2">{{
                          final.content_spoken
                          }}</span>
                      </div>
                      <div class="absolute right-0 px-2" *ngIf="targetItem?.closest('.p-picklist-target')">
                        <span class="delete-action" (click)="onDeleteTargetItem(target)">
                          <i class="delete-btn pi pi-trash"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }
            </ng-template>
          </p-pickList>
        </div>
      </div>
    </div>
  </div>
</div>